@if (isLoading) {
  <app-rings-loader></app-rings-loader>
}

<div class="modal-header">
  <h3 class="dialog-title text-center">{{ 'Add TAT' | translate }}</h3>
</div>

<div mat-dialog-content [formGroup]="form">
  <div class="modal-content">
    <div class="logo-img-container">
      <img src="assets/images/grpLogo.svg" alt="logo" class="logo-img" />
    </div>

    <div class="modal-body">
      <div class="form-fields-body">
        <div formArrayName="tatList">
          @for (tat of tatList.controls; track trackByIndex(i); let i = $index) {
            <div [formGroupName]="i" class="tat-row">
              <mat-form-field>
                <mat-label>{{ 'Turn Around Time' | translate }}</mat-label>
                <input matInput formControlName="turnAroundTime" />
                @if (tat.get('turnAroundTime')?.hasError('required')) {
                  <mat-error>
                    {{ 'Turn Around Time is required' | translate }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'Surcharge' | translate }}</mat-label>
                <input matInput formControlName="surcharge" type="number" />
                @if (tat.get('surcharge')?.hasError('required')) {
                  <mat-error>
                    {{ 'Surcharge is required' | translate }}
                  </mat-error>
                }
              </mat-form-field>
              @if (tatList.length > 1) {
                <button mat-icon-button color="warn" (click)="removeTat(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          }
        </div>

        <button class="add-tat-btn" (click)="addTat()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="createButton mt-2">
  <button class="btn modal-footer-btn save-modal-btn" (click)="save()" [class.cursor-not-allowed]="isLoading"
    [disabled]="form.invalid">
    {{'Save' | translate}}
  </button>

  <div class="createButton mt-3">
    <button class="btn modal-footer-btn cancel-modal-btn" (click)="cancel()">
      {{'Cancel' | translate}}
    </button>
  </div>
</div>